import { ShippingCourierForm } from '../../../features/shipping-couriers/ShippingCourierForm';

export const ShippingCouriersPage = () => {
  return <ShippingCourierForm />;
};
